<template>
  <div  v-if="regione" class="popup-regione">
    <a :href="url('/fesr')">
      <img :src="url('/storage/media/pop-up-regione.png')" alt="">
    </a>
    <div class="chiudi" @click="regione =  false">
      <i class="fas fa-times"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "popup-regione",
  data() {
    return {
      regione: true,
    }
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.popup-regione {
  position: fixed;
  width: 15%;

  z-index: 9;
  right: 20px;
  @media (max-width: 550px) {
    width: 55%;
    right: 20px;
    bottom: 25%;
  }
  bottom: 20px;

  .chiudi {
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 0;
    z-index: 10;
    color: #000000;
  }
}
</style>
